import { render } from "./palette.vue?vue&type=template&id=16de82a1"
import script from "./palette.vue?vue&type=script&lang=js"
export * from "./palette.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__